// extracted by mini-css-extract-plugin
export default {"root":"Mr_FwLOPAJw9EV4re9sa"};